var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFullH22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 22,
    viewBox: "0 0 124 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_5467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7956 0.0316582C16.7658 0.0316582 21.6224 4.92731 21.6224 10.9846C21.6224 13.6836 20.6631 16.1627 19.0549 18.0776C18.8693 18.2976 18.6532 18.5168 18.4364 18.7368C16.4874 20.745 13.7967 21.9692 10.8268 21.9692H0V0L10.7956 0.0316582ZM3.83562 18.0768H10.7956C14.6312 18.0768 17.7555 14.9069 17.7555 11.0154C17.7555 7.1239 14.6312 3.95403 10.7956 3.95403H3.83562V18.0768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4489 21.9683H40.118L38.1386 18.0452L33.4061 8.63051L28.6736 18.0452L26.6942 21.9683H22.3633L24.3427 18.0452L33.4061 0L42.4695 18.0452L44.4489 21.9683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5202 14.7186C57.8393 13.5886 56.6336 12.8353 55.2415 12.8353H51.3746V21.9991H47.5078V0.0316162H61.1797C62.7879 0.0316162 64.2417 0.690756 65.2938 1.7582C66.3459 2.8565 66.9948 4.33145 66.9948 5.96306C66.9948 8.34798 65.6026 11.3612 63.592 12.3028C63.0663 12.5536 62.5095 12.7103 61.9214 12.7736L64.232 17.2025L66.9948 22H62.6639L60.2316 17.8519M61.1805 8.91295C61.4589 8.91295 61.7374 8.85045 61.9846 8.72463C62.6959 8.41048 63.1599 7.27728 63.1599 6.49313C63.1599 5.77149 62.7887 4.73894 62.5727 4.51896C62.3254 4.26813 61.8614 3.95398 61.1805 3.95398H51.3746V8.9438L61.1805 8.91214V8.91295Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2028 0L90.2234 3.92318L81.16 21.9683L72.0966 3.92318L70.1172 0H74.4481L76.4275 3.92318L81.16 13.3378L85.8925 3.92318L87.8719 0H92.202H92.2028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3281 21.9683V0H99.195V21.9683H95.3281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.135 6.08811V5.96229C120.135 4.864 119.238 3.95403 118.155 3.95403H109.371C108.288 3.95403 107.391 4.864 107.391 5.96229V6.08811C107.391 7.18641 108.288 8.09638 109.371 8.09638H117.166C119.176 8.09638 120.97 8.97469 122.208 10.3563C122.301 10.4504 122.362 10.5446 122.455 10.6388C123.414 11.8312 124.002 13.3687 124.002 15.032C124.002 18.861 120.94 21.9675 117.166 21.9675H110.391C106.617 21.9675 103.555 18.861 103.555 15.032H107.422C107.422 16.6952 108.752 18.0443 110.391 18.0443H117.166C118.805 18.0443 120.166 16.6952 120.166 15.032C120.166 13.3687 118.805 12.0196 117.166 12.0196H109.371C107.793 12.0196 106.37 11.3921 105.318 10.3563C105.04 10.0738 104.792 9.75965 104.576 9.41466C103.926 8.47303 103.555 7.31223 103.555 6.05645V5.93144C103.555 2.6674 106.153 0 109.37 0H118.155C121.372 0 124.001 2.6674 124.001 5.93144V6.05645L120.134 6.08811H120.135Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_5467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullH22);
export default __webpack_public_path__ + "static/media/logo-full-H22.332236490b9127869aab543d7eaf93d3.svg";
export { ForwardRef as ReactComponent };